import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';

interface SettingsState {
  initialised: boolean;
}

// Define the initial state using that type
const initialState: SettingsState = {
  initialised: false,
};

/// THUNKS

/// SLICE

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setAppInitialised: state => {
      console.log('[Settings] appLoaded');
      state.initialised = true;
    },
  },
});

/// REDUCERS

export const { setAppInitialised } = settingsSlice.actions;

/// SELECTORS

export const selectTemplate = (state: RootState) => state.settings.initialised;

export default settingsSlice.reducer;
